class GwProductLens extends HTMLElement {
  connectedCallback() {
    this.mode = 'styles';
    try {
      if (sessionStorage.getItem('gw-product-lens') === 'colorways') this.mode = 'colorways';
    } catch {}
    this.visibility = new Map();
    this.addEventListener('click', this.onClick);
    const results = this.closest('#ResultsList');
    if (!results) return;
    this.scope = this.closest('results-list') || results;
    this.scope.addEventListener('gw:products-appended', this.onProductsAppended);
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this.scope, { childList: true, subtree: true });
    this.refresh();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
    this.scope?.removeEventListener('gw:products-appended', this.onProductsAppended);
    this.restoreVisibility();
    const panel = this.querySelector('[data-colorway-panel]');
    if (panel) panel.hidden = true;
  }

  onClick = (event) => {
    const button = event.target.closest('[data-lens-view]');
    if (!button || !this.contains(button)) return;
    const nextMode = button.dataset.lensView;
    if (nextMode !== 'styles' && nextMode !== 'colorways') return;
    this.mode = nextMode;
    try { sessionStorage.setItem('gw-product-lens', nextMode); } catch {}
    this.refresh();
  };

  onProductsAppended = (event) => {
    if (this.mode !== 'colorways' || event.target !== this.grid) return;
    this.refresh();
    const panel = this.querySelector('[data-colorway-panel]');
    const list = this.querySelector('[data-colorway-list]');
    if (!panel || panel.hidden || !list) return;
    const newStyles = new Set(event.detail.items.map((item) => item.dataset.productId));
    const firstNew = [...list.children].find((card) => newStyles.has(card.dataset.styleId));
    const target = firstNew?.querySelector('.gw-discovery-card__title a[href]');
    if (!(target instanceof HTMLElement)) return;
    target.focus({ preventScroll: false });
    event.preventDefault();
  };

  hideElement(element) {
    if (!element) return;
    if (!this.visibility.has(element)) this.visibility.set(element, element.getAttribute('hidden'));
    element.hidden = true;
  }

  restoreVisibility() {
    this.visibility?.forEach((value, element) => {
      if (value === null) element.removeAttribute('hidden');
      else element.setAttribute('hidden', value);
    });
    this.visibility?.clear();
  }

  refresh() {
    this.restoreVisibility();
    const grid = document.getElementById(this.getAttribute('grid-id'));
    const panel = this.querySelector('[data-colorway-panel]');
    const list = this.querySelector('[data-colorway-list]');
    const toolbar = this.querySelector('[data-lens-toolbar]');
    if (!grid || !panel || !list || !toolbar) return;
    const templates = [...grid.querySelectorAll('template[data-colorway-template]')];
    const changed = this.renderedGrid !== grid || templates.length !== this.renderedTemplates?.length || templates.some((template, index) => template !== this.renderedTemplates?.[index]);
    this.grid = grid;
    this.templates = templates;
    if (!templates.length) {
      toolbar.hidden = true;
      panel.hidden = true;
      return;
    }
    if (this.mode === 'colorways' && (changed || !list.childElementCount)) {
      const fragment = document.createDocumentFragment();
      templates.forEach((template) => fragment.append(template.content.cloneNode(true)));
      list.replaceChildren(fragment);
      this.renderedGrid = grid;
      this.renderedTemplates = templates;
    }
    const colorwaysActive = this.mode === 'colorways' && list.childElementCount > 0;
    toolbar.hidden = false;
    panel.hidden = !colorwaysActive;
    if (colorwaysActive) {
      this.hideElement(grid);
      this.hideElement(this.scope?.querySelector('[ref="viewMoreNext"]'));
      this.scope?.querySelectorAll('.column-options-wrapper').forEach((control) => this.hideElement(control));
    }
    this.querySelectorAll('[data-lens-view]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.lensView === (colorwaysActive ? 'colorways' : 'styles'))));
    if (colorwaysActive) {
      const styleCount = new Set([...list.children].map((card) => card.dataset.styleId)).size;
      const count = this.querySelector('[data-colorway-count]');
      const text = (this.dataset.countTemplate || '').replace('GW_COLORWAYS', String(list.childElementCount)).replace('GW_STYLES', String(styleCount));
      if (count && count.textContent !== text) count.textContent = text;
    }
  }
}

if (!customElements.get('gw-product-lens')) customElements.define('gw-product-lens', GwProductLens);
